import React, { useState } from 'react';
import { ThemeProvider } from '../../contexts/ThemeContext';
import { CallsScreen } from '../../pages/CallsScreen';
import { DeckPhoneFrame } from './DeckPhoneFrame';
interface VexuCallDetailShowcaseProps {
  scale?: number;
  /** Id of the completed call to open inside the real Calls experience. */
  callId?: number;
}

/** Emergency handling is revealed later in the deck, so it stays out of view. */
const EMERGENCY_CALL_IDS = [12];

/**
 * The real Vexu completed-call experience — summary, outcome, transcript,
 * audio and caller history — opened inside a presentation device shell.
 * The product's own deep-link prop does the work; no UI is recreated here.
 */
export function VexuCallDetailShowcase({
  scale = 0.78,
  callId = 2
}: VexuCallDetailShowcaseProps) {
  // The deep link is consumed once so the opened call is never re-opened
  // (and reset) on subsequent renders.
  const [openCallId, setOpenCallId] = useState<number | null>(callId);
  return <ThemeProvider initialMode="light" data-id="element-286" data-mp="avlxar288s8k">
      <DeckPhoneFrame scale={scale} data-id="element-287" data-mp="auk9rn40yd9y">
        <div className="h-full relative" data-id="element-288" data-mp="athkfjmcoiw5">
          <CallsScreen onNavigate={() => undefined} initialCallId={openCallId} onInitialCallOpened={() => setOpenCallId(null)} hiddenCallIds={EMERGENCY_CALL_IDS} showCommandComposer={false} data-id="element-289" data-mp="fmam1ymivb40" />
        </div>
      </DeckPhoneFrame>
    </ThemeProvider>;
}